<template>
  <el-dialog
    v-if="visible"
    :visible="visible"
    :title="title"
    fullscreen
    show-close
    width="1000px"
    top="10vh"
    :close-on-click-modal="false"
    :before-close="() => $refs.editForm.cancel()"
    :modal-append-to-body="false"
    :modal="false"
  >
    <EditForm
      ref="editForm"
      :shipmentCode="shipmentCode"
      :disabled="disabled"
      :shipmentContainerCode="shipmentContainerCode"
      @reload="$emit('reload')"
      @close="close()"
    />
    <span slot="footer">
      <el-button size="small" @click="$refs.editForm.cancel()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        v-if="!disabled"
        @click="$refs.editForm.save()"
      >
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import EditForm from './index.vue'
export default {
  components: { EditForm },
  props: {
    title: { type: String, default: '' },
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    shipmentCode: { type: String, default: '' },
    shipmentContainerCode: { type: String, default: '' },
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>

<style scoped></style>
